module.exports = __webpack_public_path__ + "static/img/hmo4.82e1234.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hmo/hmo4.png
// module id = pstX
// module chunks = 11